import React from "react";
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { GlobalColors } from "../utls/constants";

const CustomButton = ({
  title,
  type = "primary",
  size = "middle",
  icon,
  loading = false,
  disabled = false,
  onClick,
  style = {},
}) => {
  return (
    <Button
      type={type}
      size={size}
      disabled={disabled || loading}
      onClick={onClick}
      style={{
        backgroundColor: type === "primary" ? GlobalColors.primaryColor : "#f0f0f0",
        borderColor: type === "primary" ? GlobalColors.primaryColor : "#d9d9d9",
        color: type === "primary" ? "#fff" : "#000",
        fontWeight: "bold",
        borderRadius: "8px",
        boxShadow: type === "primary" ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none",
        padding: "8px 16px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        ...style,
      }}
    >
      {loading ? <LoadingOutlined /> : icon} {title}
    </Button>
  );
};

CustomButton.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["primary", "default", "dashed", "link", "text"]),
  size: PropTypes.oneOf(["small", "middle", "large"]),
  icon: PropTypes.element,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default CustomButton;
